import { Injectable } from '@angular/core';

@Injectable()
export abstract class UserMessagePopup {
    abstract OpenUserMessagePopup(): void;
}

